import React from 'react';
import { Timer } from '@phosphor-icons/react';

export function formatElapsed(secs) {
  const s = Math.max(0, Math.floor(secs || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
  return `${m}:${String(ss).padStart(2, '0')}`;
}

/** Compact timer pill – used on the persistent session bar and in dense headers. */
export function WorkoutTimerPill({ seconds, tone = 'light', testId = 'workout-timer-pill' }) {
  const styles =
    tone === 'dark'
      ? { backgroundColor: 'rgba(255,255,255,0.18)', color: '#EDEAE3' }
      : { backgroundColor: 'rgba(25,28,33,0.06)', color: 'inherit' };
  return (
    <span className="timer-pill text-[11px]" style={styles} data-testid={testId}>
      <Timer size={12} weight="bold" />
      <span className="tabular-nums">{formatElapsed(seconds)}</span>
    </span>
  );
}

/** Large timer – lives in the Session header so the user can eyeball their pace. */
export function WorkoutTimerLarge({ seconds, testId = 'workout-timer-large' }) {
  return (
    <div className="flex items-baseline gap-2" data-testid={testId}>
      <Timer size={14} weight="bold" className="text-graphite/60" />
      <span className="text-2xl font-black font-heading tabular-nums text-graphite leading-none">
        {formatElapsed(seconds)}
      </span>
      <span className="text-[10px] uppercase tracking-[0.24em] font-bold text-graphite/50">
        Elapsed
      </span>
    </div>
  );
}
